module.exports = __webpack_public_path__ + "img/Falkberget_Liv_Ullmann.804ac553.jpg";